import React from 'react';
import { IAppointment } from '../API/GoMoto';
import { AppointmentDispatchTypes, useAppointmentDispatch, useAppointmentUpdateAndPersist } from '../context/Appointment/appointment';
import { useStepReducer } from './stepReducer';

/**
 * Hook that will correctly clear an existing appointment and assign new values before completing.
 * @param appointment The appointment as provided by useEnsureAppointment
 */
export const useNotListedReducer = (appointment?: IAppointment) => {
    // TODO: We can probably move this logic into useEnsureAppointment to generate a new appointment.
    const appointmentdispatch = useAppointmentDispatch();
    const setAppointment = useAppointmentUpdateAndPersist();
    const { current, next, start } = useStepReducer(['clear-existing-appointment', 'ensure-blank-appointment', 'assign-appointment']);
    const [baseAppointment, setBaseAppointment] = React.useState(
        {} as
        | Pick<IAppointment, 'firstName' | 'lastName' | 'businessName' | 'accountType' | 'phone' | 'email'>
        | Pick<IAppointment, 'phone'>
        | Pick<IAppointment, 'email'>,
    );

    React.useEffect(() => {
        switch (current) {
            case 'clear-existing-appointment':
                if (appointment) {
                    appointmentdispatch({ type: AppointmentDispatchTypes.RemoveAndKeepInitialInteraction });
                }
                next();
                break;
            case 'ensure-blank-appointment':
                if (appointment) {
                    next();
                }
                break;
            case 'assign-appointment':
                if (appointment) {
                    const assignedAppointment = { ...appointment,
                        ...baseAppointment } as typeof appointment;
                    setAppointment(assignedAppointment);
                    next();
                }
                break;
        }
    });

    return {
        status: current,
        inProgress: current !== 'not-started' && current !== 'complete',
        complete: current === 'complete',
        start: (baseAppt: typeof baseAppointment) => {
            setBaseAppointment(baseAppt);
            start();
        },
    };
};
